import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://kanguroo-crm-production.up.railway.app/api/v1';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getDashboard = () => api.get('/finance/reports/dashboard');
export const getOverdueInvoices = () => api.get('/finance/reports/overdue');
export const getProfitability = () => api.get('/finance/reports/profitability');

export const getInvoices = (params = {}) => api.get('/finance/invoices/', { params });
export const getInvoice = (id) => api.get(`/finance/invoices/${id}`);
export const createInvoice = (data) => api.post('/finance/invoices/', data);
export const updateInvoice = (id, data) => api.put(`/finance/invoices/${id}`, data);
export const updateInvoiceStatus = (id, data) => api.patch(`/finance/invoices/${id}/status`, data);
export const deleteInvoice = (id) => api.delete(`/finance/invoices/${id}`);

export const getExpenses = (params = {}) => api.get('/finance/expenses/', { params });
export const getExpense = (id) => api.get(`/finance/expenses/${id}`);
export const createExpense = (data) => api.post('/finance/expenses/', data);
export const updateExpense = (id, data) => api.put(`/finance/expenses/${id}`, data);
export const updateExpenseStatus = (id, data) => api.patch(`/finance/expenses/${id}/status`, data);
export const deleteExpense = (id) => api.delete(`/finance/expenses/${id}`);

export const getApprovals = () => api.get('/finance/approvals/');
export const approveRequest = (id, note) => api.post(`/finance/approvals/${id}/approve`, { reviewer_note: note });
export const rejectRequest = (id, note) => api.post(`/finance/approvals/${id}/reject`, { reviewer_note: note });
export const deferRequest = (id, date, note) => api.post(`/finance/approvals/${id}/defer`, { deferred_until: date, reviewer_note: note });
